import React from "react";
import "./newnav.css";
import { Link } from "react-router-dom";

const Newnav = () => {
  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" className="navbar-brand" style={{ fontWeight: "600" }}>
          Double Knot Collective
        </Link>
      </div>
      <div className="navbar-right">
        <Link to="/portfolio" style={{ fontWeight: "600" }}>
          Portfolio
        </Link>
        <div className="dropdown">
          <Link
            className="dropbtn"
            to="/services"
            style={{ fontWeight: "600" }}
          >
            Services
          </Link>
          <div className="dropdown-content">
            <Link to="/services/proposal">Proposal/Engagement</Link>
            {/* <Link to="/services/engagements">Engagement</Link> */}
            <Link to="/services/wedding">Wedding</Link>
          </div>
        </div>
        <Link to="/contact-us" style={{ fontWeight: "600" }}>
          Contact
        </Link>
      </div>
    </nav>
  );
};

export { Newnav };
